import React from 'react';
import moment from 'moment';

/**
 * Warehouse "picking" receipt for the logistics team — articles + quantities
 * only, no prices. Hidden on screen; a print stylesheet hides everything else
 * on the page and shows just this block, sized for an 80mm thermal printer.
 * Printing is triggered by the parent via window.print().
 */
const PickingReceipt = ({ sale }) => {
  return (
    <div className='picking-receipt' aria-hidden='true'>
      <style>{`
        .picking-receipt { display: none; }
        @media print {
          @page { size: 80mm auto; margin: 3mm; }
          body * { visibility: hidden !important; }
          .picking-receipt, .picking-receipt * { visibility: visible !important; }
          .picking-receipt {
            display: block !important;
            position: absolute; left: 0; top: 0; width: 72mm;
            /* Heavy sans-serif renders far darker on a 180dpi thermal head
               than a thin monospace like Courier. */
            font-family: Arial, Helvetica, sans-serif;
            color: #000 !important;
            font-weight: 700;
            line-height: 1.25;
            /* Stop the browser from lightening/greying the print. */
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
          .picking-receipt h2 { font-size: 26px; font-weight: 900; margin: 0 0 8px; line-height: 1.15; }
          .picking-receipt .meta { font-size: 18px; font-weight: 700; }
          .picking-receipt table { width: 100%; border-collapse: collapse; margin-top: 6px; }
          .picking-receipt td { padding: 6px 0; font-size: 24px; font-weight: 700; vertical-align: top; }
          .picking-receipt td.qty { font-size: 30px; font-weight: 900; white-space: nowrap; padding-right: 12px; }
          .picking-receipt hr { border: none; border-top: 2px solid #000; margin: 8px 0; }
          .picking-receipt .foot { font-size: 18px; font-weight: 700; margin-top: 10px; }
          .picking-receipt .dummy-banner {
            font-size: 22px; font-weight: 900; text-align: center;
            border: 3px solid #000; padding: 6px; margin-bottom: 8px;
          }
        }
      `}</style>
      {sale && (
        <div>
          {sale.dummy && <div className='dummy-banner'>DUMMY / TEST BELEG</div>}
          <h2>ABHOLBELEG</h2>
          <h3>[G]etränkemar[K]t</h3>
          <div className='meta'>
            {moment(sale.time).format('DD.MM.YYYY HH:mm')}
          </div>
          <div className='meta'>Beleg: {String(sale.txId || '—').slice(0, 8)}</div>
          {sale.customerName ? (
            <div className='meta'>Kunde: {sale.customerName}</div>
          ) : null}
          <hr />
          <table>
            <tbody>
              {sale.items.map((item, idx) => (
                <tr key={idx}>
                  <td className='qty'>{item.amount}×</td>
                  <td>{item.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <hr />
          <div className='foot'>
            {sale.dummy
              ? 'Nur zum Testen des Druckers — kein echter Beleg.'
              : 'Bitte aus dem Lager kommissionieren.'}
          </div>
        </div>
      )}
    </div>
  );
};

export default PickingReceipt;
